<style lang="scss" type="text/scss">
  .section-nav-fixed {
    position: -webkit-sticky;
    position: sticky;
    top: 16px;
  }

  .section-nav-fixed.has-sub {
    /*
    need additional rule here for popover...
    */
    top: 64px;
  }

  .section-nav {
    background: #fff;
    border-radius: 4px;

    box-shadow: -1px 0 62px -6px rgba(0, 0, 0, 0.15);

    margin-bottom: 16px;
    border: none;
    position: relative;

    transition: all 0.3s;
    width: 100%;
  }

  .section-nav :global(ul) {
    list-style: none;
    margin: 0;
    padding: 0 0;
    width: 100%;
    display: block;
    margin-bottom: 16px;
  }

  .section-nav :global(li) {
    width: 100%;
    text-align: center;
    font-family: proxima-nova, sans-serif;
    font-weight: 500;
    font-size: 15px;
    color: #4c4c4b;
    padding: 16px;
    cursor: pointer;

    &.active {
      color: #ff6452;
      background: #fbfbfb;
    }
  }

  .section-nav :global(.save) {
    width: 100%;
    background: #ff6452;
    padding: 16px;
    color: #fff;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    text-align: center;
    font-family: proxima-nova, sans-serif;
    font-weight: 500;
    font-size: 15px;
    color: #fff;
    border-radius: 4px;
    cursor: pointer;
  }

  .section-nav :global(.save.bottom) {
    width: 100%;
    background: #ff6452;
    padding: 16px;
    color: #fff;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    text-align: center;
    font-family: proxima-nova, sans-serif;
    font-weight: 500;
    font-size: 15px;
    color: #fff;
    border-radius: 4px;
    cursor: pointer;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  .section-nav-fixed .under :global(a) {
    color: #fff;
    background: #ff6452;
    padding: 4px 8px;
    border-radius: 4px;
    font-family: proxima-nova, sans-serif;
    font-weight: 600;
    font-size: 13px;
  }
</style>

<script>
  export let hasSub = false;
</script>

<div class="section-nav-fixed" class:has-sub="{hasSub}">
  <div class="section-nav">
    <slot></slot>
  </div>
  <div class="under">
    <slot name="under"></slot>
  </div>
</div>
